<template>
  <div>
    <h5>Star Ratings</h5>
    <el-switch v-for="(rating, index) in getRatings"
               v-model="rating.selected"
               :active-text="ratingFinalName(rating)"
               @change="storeRatingGlobally({ratingIndex: index, ratingData:rating})"
               style="padding-left: 15px;">
    </el-switch>
  </div>
</template>

<script>
  export default {
    data(){
      return {

      }
    },
    methods: {
      storeRatingGlobally(channelObject){
        this.$store.dispatch('replaceSpecificChannel', channelObject);
      },
      ratingFinalName(ratingObject){
        return ratingObject.meta_value + ' Star Rating ('+ ratingObject.star_amount +')';
      }
    },
    computed: {
      getRatings: { //2way binding automatically detects if get or set to use! AWESOME!
        get() {
          return this.$store.getters.getMPPStars;
        },
        set(value) { //method not used by Element UI ... using change() provided by UI with custom method instead
          this.$store.dispatch('setStars', value);
        }
      },
    }
  }
</script>

<style scoped lang="scss">

</style>